import question_data from './data';

const checkEligibility = (answers, currentQuestion, setStageOneEligible, setIneligible, setEligible) => {
    const currentAnswer = answers.hasOwnProperty(currentQuestion) ? answers[currentQuestion] : null;
    const currentAnswerKey = currentAnswer.hasOwnProperty('key') ? currentAnswer.key : null;

    if (currentAnswer) {
        // Stage 1 questions.
        if (question_data[currentQuestion].stage === 1) {
            if (answers[currentQuestion].eligible === true) {
                setStageOneEligible(true);
            } else {
                setStageOneEligible(false);
            }
        }
        // Stage 2 questions.
        else {
            // If nextQuestion property for answer is null - flagging that this answer shouldn't take the user to the
            // next question because they ave either eligible or ineligible now.

            // Check answers for sub-questions/
            if (currentAnswer.hasOwnProperty(currentAnswerKey) && !currentAnswer[currentAnswerKey].nextQuestion) {
                // Ineligible.
                if (currentAnswer[currentAnswerKey].eligible === false) {
                    setIneligible(true);
                }
                // Eligible.
                else if (currentAnswer[currentAnswerKey].eligible === true) {
                    setEligible(true);
                }
            }
            // Check answer for top level answer - only if there are no sub questions to check
            else if (!currentAnswer.nextQuestion) {
                // Ineligible.
                if (currentAnswer.eligible === false) {
                    setIneligible(true);
                }
                // Eligible.
                else if (currentAnswer.eligible === true) {
                    setEligible(true);
                }
            }
        }
    }
};

export { checkEligibility };
